<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner" @click="handleCloseMenu">
      <white-menu ref="whiteMenu"></white-menu>
    </div>
    <div class="bgColor">
      <div class="title">
        <checkout-header>
          <div>
            <span class="title-font">Shopping Bag</span>
          </div>
        </checkout-header>
        <div class="wrapper box-bottom" v-show="isShowNull == 0">
          <!-- 左边商品 -->
          <div class="left goodsList ipad-padding">
            <div class="goods-title">Total({{goodsList.length}})</div>
            <div class="line-body">
              <div class="triangle-left"></div>
              <div class="line"></div>
              <div class="triangle-right"></div>
            </div>
            <div class="division-box box-top">
              <div class="division division-top"></div>
            </div>
            <div class="goodsList">
              <div class="ul-box">
                <ul>
                  <li v-for="(goods,index) in goodsList" :key="index">
                    <div class="wrapper goods-box" @click="showGoodsInfo(goods.goodsId,index)">
                      <img class="box-img box-top" :src="goods.picUrl" alt style="width:150px;height: 150px;"/>
                      <div class="box-name box-top">
                        <div class="brand">{{ goods.brandName }}</div>
                        <div class="name">{{ goods.goodsName }}</div>
                        <div class="sku">{{ goods.serialNumber }}</div>
                      </div>
                      <div class="box-price box-top">
                        <div class="price">HK${{ goods.originalPrice }}.00</div>
                      </div>
                      <img
                        class="delete-img box-top"
                        @click.stop="removeGoods(goods.goodsId,index)"
                        src="../assets/shopping/Frame 62.png"
                        alt
                      />
                    </div>
                    <div class="division-box">
                      <div class="division"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 右边结算 -->
          <div class="right ipad-padding">
            <div class="right-box">
              <div class="goods-title" style="visibility: hidden">Total({{goodsList.length}})</div>
              <div class="line-body1">
                <div class="triangle-left"></div>
                <div class="line"></div>
                <div class="triangle-right"></div>
              </div>
              <div class="total-box box-top">
                <div class="left-text">Subtotal</div>
                <div class="right-text">HK${{ subtotal }}.00</div>
              </div>
              <div class="division"></div>
              <div class="total-box">
                <div class="left-text">Shipping Cost</div>
                <div class="right-text">HK${{ shippingCost }}.00</div>
              </div>
              <div class="division"></div>
              <div class="open-box">
                <div class="total-box">
                  <div
                    class="left-text text-color"
                  >VAT/GST NOT INCLUDED</div>
                  <img
                    class="arrow-down"
                    @click="openPrompt"
                    v-show="isOpen == 0"
                    src="../assets/shopping/Vector 172.png"
                    alt
                  />
                  <img
                    class="arrow-down"
                    @click="openPrompt"
                    v-show="isOpen == 1"
                    src="../assets/shopping/Vector 172 (2).png"
                    alt
                  />
                </div>
              <!-- <div class="open-box" :class="isOpen==0?'':'select-color'">
                <div class="total-box">
                  <div
                    class="left-text"
                    :class="isOpen==0?'text-color':'text-color-select'"
                  >VAT/GST NOT INCLUDED</div>
                  <img
                    class="arrow-down"
                    @click="openPrompt"
                    v-show="isOpen == 0"
                    src="../assets/shopping/Vector 172.png"
                    alt
                  />
                  <img
                    class="arrow-down"
                    @click="openPrompt"
                    v-show="isOpen == 1"
                    src="../assets/shopping/Vector 172 (1).png"
                    alt
                  />
                </div> -->
                <!-- <div class="prompt-box" v-show="isOpen==1">
                  <span :class="isOpen==0?'prompt-black':'checkout'">
                    International shoppers are required to pay customs charges as
                    well as any associated import tax, VAT, or duties as required by
                    your local jurisdiction. Contact your Client Advisor or read more
                  </span>
                  <span
                    class="prompt-wrap"
                    :class="isOpen==0?'prompt-black':'checkout'"
                    @click="aboutShipping()"
                  >ABOUT SHIPPING.</span>
                </div>
                <div class="division right-box line-color"></div>
                <div class="total-box">
                  <div class="left-text" :class="isOpen==0?'prompt-black':'checkout'">Total Price</div>
                  <div
                    class="right-text"
                    :class="isOpen==0?'prompt-black':'checkout'"
                  >HK${{ totalPrice }}.00</div>
                </div>
                <div
                  class="checkout-box wrapper"
                  :class="isOpen==0?'':'prompt-box-bgColor'"
                  @click="clickCheckout"
                >
                  <div :class="isOpen==0?'checkout':'prompt-text-select'">CHECKOUT</div>
                </div> -->
                <div class="prompt-box" v-show="isOpen==1">
                  <span class="prompt-black">
                    International shoppers are required to pay customs charges as
                    well as any associated import tax, VAT, or duties as required by
                    your local jurisdiction. Contact your Client Advisor or read more
                  </span>
                  <span
                    class="prompt-wrap prompt-black"
                    @click="aboutShipping()" style="cursor:pointer;"
                  >ABOUT SHIPPING.</span>
                </div>
                <div class="division right-box line-color"></div>
                <div class="total-box">
                  <div class="left-text prompt-black">Total Price</div>
                  <div
                    class="right-text prompt-black"
                  >HK${{ totalPrice }}.00</div>
                </div>
                <div
                  class="checkout-box wrapper"
                  @click="clickCheckout"
                >
                  <div class="checkout">CHECKOUT</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper nullBox-height" v-show="isShowNull == 1">
          <div class="null-font">No products have been added at present~</div>
        </div>
        <!-- 下面横幅 -->
        <div class="wrapper help">
          <div>
            <span class="help-title">NEED</span>
            <span class="help-title text-color-select">HELP</span>
            <span class="help-title">?</span>
          </div>
        </div>
        <!-- bgColor-white -->
        <div class="wrapper bgColor-white">
          <!-- 联系方式 -->
          <div class="left contact-faq">
            <div class="goods-title box-top">Contact us right now</div>
            <div class="line-body">
              <div class="triangle-left"></div>
              <div class="line"></div>
              <div class="triangle-right"></div>
            </div>
            <div class="goodsList box-top contact-height">
              <ul>
                <li v-for="(contact,index) in contactList" :key="index">
                  <div class="contact-box" @click="clickContacts(contact.id,index)">
                    <img class="contact-img" :src="contact.src" alt />
                    <div class="name contact-left">{{ contact.contact }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 常见问题 -->
          <div class="right contact-faq">
            <div class="goods-title box-top">FAQs about buying</div>
            <div class="line-body">
              <div class="triangle-left"></div>
              <div class="line"></div>
              <div class="triangle-right"></div>
            </div>
            <div class="goodsList contact-height">
              <ul>
                <li v-for="(faq,index) in FAQ" :key="index">
                  <div class="contact-box faq-height" @click="clickFAQS(faq.id,index)">
                    <div class="name">{{ faq.wenti }}</div>
                  </div>
                  <div class="division-box division"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WhiteMenu from "@/components/WhiteMenu";
import CheckoutHeader from "@/components/CheckoutHeader";
import store from "@/store";
import { queryCarByUserId, getGoodsDetail,removeCarByCondition } from "@/api/shoppingBag";
import { getBuy,setBuy,removeBuy } from "../utils/auth";
import { queryCarByString } from "@/api/order";

export default {
  name: "ShoppingBagView",
  components: {
    WhiteMenu,
    CheckoutHeader
  },
  data() {
    return {
      goodsList: [],
      contactList: [],
      FAQ: [],
      subtotal: "0",
      shippingCost: "0",
      totalPrice: "0",
      isOpen: 0,
      gid: "",
      isShowNull: 1
    };
  },
  created() {
    (this.goodsList = [
      {
        id: 1,
        src: require("@/assets/xh/images/checkout1.png"),
        brand: "Omega",
        name: "Constellation",
        sku: "SKU#4568910",
        price: "180,000,000"
      },
      {
        id: 2,
        src: require("@/assets/xh/images/checkout1.png"),
        brand: "Omega",
        name: "Constellation",
        sku: "SKU#4568910",
        price: "180,000,000"
      }
    ]),
      (this.contactList = [
        {
          id: 1,
          src: require("@/assets/shopping/Frame 168.png"),
          contact: "+852 1111 2222"
        },
        {
          id: 2,
          src: require("@/assets/shopping/Frame 168.png"),
          contact: "+852 2222 3333"
        },
        {
          id: 3,
          src: require("@/assets/shopping/Frame 168.png"),
          contact: "+852 2222 3333"
        }
      ]),
      (this.FAQ = [
        {
          id: 1,
          url: "https://www.baidu.com",
          wenti:
            "Lörem ipsum parara kat i tisiligt. Öråd igon, om än enade i syssna. "
        },
        {
          id: 2,
          url: "https://www.baidu.com",
          wenti:
            "Lörem ipsum parara kat i tisiligt. Öråd igon, om än enade i syssna. "
        }
      ]);
  },
  mounted: function() {
    console.log('===')
    console.log(this.$store.getters.userId)
    if (!this.$store.getters.userId) {
      this.gid = getBuy();
      this.isShowNull = 1;
      if (this.gid && this.gid.length>0) {
        this.isShowNull = 0
        queryCarByString(this.gid).then(res => {
          console.log("gids:"+this.gid);
          console.log(res.data.data);
          this.goodsList = res.data.data;
        });
      }
    } else {
      this.isShowNull = 1
      queryCarByUserId({ userId: this.$store.getters.userId })
        .then(response => {
          console.log("response: ", response);
          if (response.data.errno == 0 && response.data.data) {
            this.goodsList = response.data.data;
            console.log("goodsList: ", this.goodsList);
            console.log(this.goodsList.length)
            if(this.goodsList.length>0){
              console.log('来了===')
              this.isShowNull = 0
            }
          }
        })
        .catch(err => {
          console.log("err: ", err);
        });
    }
  },
  methods: {
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu");
      if (!sp.contains(event.target)) {
        this.$refs.whiteMenu.searchFocus = false;
        this.$refs.whiteMenu.isHovered = false;
      }
    },
    openPrompt() {
      this.isOpen = !this.isOpen;
    },
    showGoodsInfo(id, index) {
      var goods = this.goodsList[index];
      console.log("跳转商品详情:" + goods);
      this.$router.push(
        { name: "watchpage", params: { id: goods.goodsId } },
        () => {}
      );
    },
    removeGoods(id, index) {
      //删除购物车的商品 首先是要查询用户id，如果未登录，则从缓存里面取goodsId
      //var gid=getBuy() 这里存的是未登录时，存入的购物车goodsId 中间用的逗号拼接的
      if (this.gid.length) {
        console.log("未登录");
        this.goodsList.splice(index, 1);
        if (this.gid.indexOf(",") != -1) {
          var gg=this.gid.split(',')
          console.log(gg)
          for (let i=0; i<gg.length; i++){
              if (gg[i] == id){
                gg.splice(i, 1)
              }
         }
         setBuy(gg.join())
         this.gid=gg.join()
        }else{
          removeBuy()
          this.isShowNull = 1
          this.gid=""
        }
      } else {
        console.log("已登录")
       // 删除购物车信息
       this.goodsList.splice(index, 1)
       if(this.goodsList.length==0){
          this.isShowNull = 1
       }
        removeCarByCondition({userId:this.$store.getters.userId,goodsId:id}).then(response=>{
          console.log('成功')
        }).catch(erro=>{
          console.log("err: ", erro);
        })

      }
    },
    clickCheckout() {
      this.$router.push("/checkout")

    },
    clickContacts(id, index) {},
    clickFAQS(id, index) {},
    aboutShipping() {
      //跳转首页
      this.$router.push('/')
    },
    total() {
      if (this.goodsList.length) {
        var total = 0;
        for (var index = 0; index < this.goodsList.length; index++) {
          var goods = this.goodsList[index];
          total += parseFloat(goods.originalPrice);
        }
        this.subtotal = this.totalPrice = total.toString();
      } else {
        this.subtotal = this.totalPrice = "0";
      }
    }
  },
  watch: {
    goodsList: {
      handler(val) {
        console.log("计算总价");
        if (val) {
          this.total();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.bgColor {
  background: #fafafa;
}
.bgColor-white {
  background: white;
}
.title {
  margin-top: 200px;
}
.title-font {
  font-size: 32px;
}
// 左边样式
.goods-title {
  margin-left: 60px;
  margin-top: 18px;
  font-size: 32px;
}
.wrapper {
  display: flex;
  justify-content: center;
}
.box-bottom {
  margin-bottom: 248px;
}
.nullBox-height {
  height: 400px;
  @extend .wrapper;
}
.goodsList {
  overflow: auto;
}
.ul-box {
  margin-bottom: 54px;
  margin-top: 0px;
}
.wrapper .goods-box {
  align-items: flex-start;
}
.wrapper .left {
  flex-direction: column;
  width: 55%;
  background: white;
}
.wrapper .right {
  flex-direction: column;
  width: 30%;
  background: white;
  margin-left: 55px;
}
.wrapper .contact-faq {
  width: 760px;
  height: 432px;
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
}
.line-body {
  height: 1px;
  @extend .division-box;
}
.line-body1 {
  height: 1px;
  display: flex;
}
.division-box {
  display: flex;
  margin-left: 60px;
  margin-right: 60px;
}
.division-box .box-top {
  margin-top: 15px;
  height: 100px;
}
.division {
  background: #969696;
  height: 1px;
  flex-basis: 100%;
}
.division-top {
  margin-top: 54px;
}
.line {
  height: 1px;
  background: black;
  display: flex;
  flex-basis: 100%;
  margin-top: 4.4px;
  margin-left: -8px;
  margin-right: -8px;
}
.triangle-left {
  width: 0;
  height: 0;
  border: 5px solid;
  border-color: transparent transparent transparent black;
}
.triangle-right {
  width: 0;
  height: 0;
  border: 5px solid;
  border-color: transparent black transparent transparent;
}
.help {
  background: #000;
  width: 100%;
  height: 100px;
  align-items: center;
}
.help-title {
  font-size: 30px;
  color: white;
}
.goods-box .box-img {
  margin-left: 72px;
  margin-bottom: 32px;
}
.goods-box .box-name {
  margin-left: 36px;
  flex-direction: column;
  flex: 1;
}
.contact-box {
  margin-left: 72px;
  margin-right: 72px;
  display: flex;
  align-items: center;
}
.right li:first-child .contact-box {
  margin-top: 10px;
}
.contact-box .contact-img {
  margin-top: 15px;
  margin-bottom: 10px;
}
.box-name .brand {
  color: #072d79;
  font-size: 16px;
}
.box-name .name {
  font-size: 20px;
}
.box-name .sku {
  color: #979797;
  font-size: 16px;
}
.goods-box .box-price {
  flex-direction: column;
  flex: 1;
}
.box-price .price {
  font-size: 20px;
}
.box-top {
  margin-top: 34px;
}
.delete-img {
  margin-right: 81px;
}
// 右边样式
.right-box {
  margin-left: 40px;
  margin-right: 40px;
}
.total-box {
  display: flex;
  height: 70px;
  align-items: center;
}
.total-box .box-top {
  margin-top: 32px;
}
.left-text {
  margin-left: 45px;
  font-size: 18px;
}
.text-color {
  color: #072d79;
}
.text-color-select {
  color: #f8d7a4;
}
.right-text {
  margin-right: 29px;
  flex: 1;
  text-align: right;
}
.arrow-down {
  width: 11px;
  margin-left: 18px;
}
.checkout-box {
  margin-left: 36px;
  margin-right: 36px;
  height: 48px;
  background-color: black;
  align-items: center;
}
.checkout {
  color: white;
}
.line-color {
  color: #969696;
}
.prompt-black {
  color: black;
}
.select-color {
  background-color: #15253f;
}
.prompt-text-select {
  color: #15253f;
}
.prompt-box-bgColor {
  background-color: #f8d7a4;
}
.prompt-box {
  margin-left: 55px;
  margin-right: 35px;
  margin-bottom: 40px;
}
.prompt-box .prompt-wrap {
  text-decoration: underline;
}
.open-box {
  margin-left: -40px;
  margin-right: -40px;
}
.contact-left {
  margin-left: 21px;
}
.contact-height {
  margin-bottom: 0px;
  flex: 1;
  overflow: auto;
}
.faq-height {
  height: 60px;
}
.null-font {
  font-size: 30px;
}

@media (max-width: 1024px) {
  .title {
    margin-top: 150px;
  }
  .title-font {
    font-size: 24px;
  }
  .box-bottom {
    flex-direction: column;
  }
  .wrapper .left {
    width: 100%;
  }
  .wrapper .right {
    width: 100%;
    margin-left: 0;
  }
  .right-box {
    margin-left: 60px;
    margin-right: 60px;
  }
  .ipad-padding {
    padding: 0 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ShoppingBagView.vue